import { render } from "./ButtonMobileNext.vue?vue&type=template&id=0be2a74e"
import script from "./ButtonMobileNext.vue?vue&type=script&lang=js"
export * from "./ButtonMobileNext.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__